/* unplugin-vue-components disabled */import { render } from "./chatbotIcon.vue?vue&type=template&id=878e72dc"
import script from "./chatbotIcon.vue?vue&type=script&lang=js"
export * from "./chatbotIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__